module.exports = __webpack_public_path__ + "static/media/Hyaluron_Collagen_komplex_kapky_retina.904c1de3.jpg";